// extracted by mini-css-extract-plugin
export default {"tab":"styles_tab__DwZzg","active":"styles_active__vOKca"};